import React from 'react';
import PropTypes from 'prop-types';
import { TableCell } from 'smartsuite-ui';
import { noDataIdentifier } from '../../../../shared/constants/constants';
import { getFormattedTimeFromMilliseconds } from '../../utils/dataFormatUtils';

// eslint-disable-next-line complexity
export default function Duration(props) {
    // prettier-ignore
    const formattedValue =
        props.cellValue === null || props.cellValue === undefined
            ? noDataIdentifier
            : getFormattedTimeFromMilliseconds(
                props.cellValue,
                props.durationTimeFormat
            );

    return (
        <TableCell
            cssClassModifiers={[props.isLeftAligned ? 'left-align' : '']}
        >
            {formattedValue}
        </TableCell>
    );
}

Duration.propTypes = {
    cellValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    durationTimeFormat: PropTypes.string,
    isLeftAligned: PropTypes.bool,
};

Duration.defaultProps = {
    isLeftAligned: false,
};
